import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import SurveyQuestionsService from "../service/surveyQuestions";
import HttpClient from "../network/http";
import { fetchCsrfToken, useAuthContext } from "../context/AuthContext";

const baseURL = process.env.REACT_APP_BASE_URL;

export default function useSurveyQuestions(conditions) {
  const { address } = useAuthContext();
  const httpClient = new HttpClient(baseURL, () => fetchCsrfToken(), address);
  const surveyQuestionsService = new SurveyQuestionsService(httpClient);
  const queryClient = useQueryClient();

  const surveyQuestionsAllQuery = useQuery(
    ["surveyQuestionsAll", conditions],
    () => surveyQuestionsService.findAllSurveyQuestionsAll(conditions),
    {
      enabled: !!conditions?.schoolid && !!conditions?.survey_id,
      staleTime: 1000 * 60 * 1, // 1분
      onError: (error) => {
        console.error("설문 질문 조회 오류:", error);
      },
      onSuccess: (data) => {
        console.log("surveyQuestions all API 성공");
      },
    }
  );

  const surveyQuestionsQuery = useQuery(
    ["surveyQuestions", conditions],
    () => surveyQuestionsService.findAllSurveyQuestions(conditions),
    {
      enabled: !!conditions?.schoolid && !!conditions?.survey_id,
      staleTime: 1000 * 60 * 1, // 1분
      onError: (error) => {
        console.error("설문 질문 조회 오류:", error);
      },
      onSuccess: (data) => {
        console.log("surveyQuestions common API 성공");
      },
    }
  );

  const surveyQuestionsBySubjectQuery = useQuery(
    ["surveyQuestionsBySubject", conditions],
    () => surveyQuestionsService.findSurveyQuestionsBySubject(conditions),
    {
      enabled:
        !!conditions?.schoolid &&
        !!conditions?.survey_id &&
        !!conditions?.subject_id,
      staleTime: 1000 * 60 * 1, // 1분
      onError: (error) => {
        console.error("과목별 설문 질문 조회 오류:", error);
      },
    }
  );

  const createOrUpdateSurveyQuestions = useMutation(
    (data) => surveyQuestionsService.createOrUpdateSurveyQuestions(data),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["surveyQuestions", conditions]);
      },
      onError: (error) => {
        console.error("설문 질문 생성/수정 오류:", error);
      },
    }
  );

  const deleteSurveyQuestion = useMutation(
    (id) => surveyQuestionsService.deleteSurveyQuestion(id),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["surveyQuestions", conditions]);
      },
      onError: (error) => {
        console.error("설문 질문 삭제 오류:", error);
      },
    }
  );

  const checkQuestionHasAnswers = useMutation(
    (questionId) => surveyQuestionsService.checkQuestionHasAnswers(questionId),
    {
      onError: (error) => {
        console.error("질문 응답 확인 오류:", error);
      },
    }
  );

  return {
    surveyQuestionsQuery,
    surveyQuestionsBySubjectQuery,
    createOrUpdateSurveyQuestions,
    deleteSurveyQuestion,
    checkQuestionHasAnswers,
    surveyQuestionsAllQuery,
  };
}
